import "./ContactUs.css";
import "./ResponsiveContactUs.css";
import { getTranslatedText as translate } from "../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));
  const navigate = useNavigate();

  return (
    <div>
      <button onClick={() => navigate(-1)} style={{ border: "none" }}>
        <span className="back-from-contact">
          <i className="bi bi-arrow-left-square-fill"></i>
        </span>
      </button>
      <div className="StartUp">
        <div
          className="StartUp-container ContactUs-container row"
          dir={locale === "AR" ? "rtl" : "ltr"}
        >
          {/* Information */}
          <div className="Startup-form-container col" dir="auto">
            <span className="header-info-contact">
              {translate("first-contactUs-header", locale)}
            </span>

            <div>
              <i className="bi fa-lg bi-geo-alt-fill icon-contact"></i>
              <span className="header-method-contact">
                {translate("location-communicate-label", locale)}
              </span>
              <span className="text-method-contact">
                {translate("location-communicate-value", locale)}
              </span>
            </div>

            <div>
              <span className="header-method-contact">
                <i className="bi bi-telephone-fill icon-contact"></i>
                {translate("phone-communicate-label", locale)}
              </span>
              <span className="text-method-contact">
                {translate("phone-communicate-value", locale)}
              </span>
            </div>

            <div>
              <span className="header-method-contact">
                <i className="bi bi-envelope-fill icon-contact"></i>
                {translate("email-communicate-label", locale)}
              </span>
              <span className="text-method-contact">
                {translate("email-communicate-value", locale)}
              </span>
            </div>
          </div>

          {/* Form */}
          <div className="Startup-form-container col-7" dir="auto">
            <span className="header-info-contact">
              {translate("second-contactUs-header", locale)}
            </span>
            <form>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  {translate("name-label", locale)}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder={translate("name-placeholder", locale)}
                  defaultValue=""
                />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  {translate("email-send-message-label", locale)}
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder={translate(
                    "email-send-message-placeholder",
                    locale
                  )}
                  defaultValue=""
                />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  {translate("message-contactUs-label", locale)}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder={translate(
                    "message-contactUs-placeholder",
                    locale
                  )}
                  defaultValue=""
                />
              </div>
              <button type="submit" className="btn btn-primary btn-contact">
                {translate("button-send-message-contactUs", locale)}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
